<template>
    <q-table
      :columns="columns"
      :rows="filteredClientUsers"
      selection="multiple"
      :selected="selected"
      :selected-rows-label="selectedLabel"
      :loading="isLoading"
      :rows-per-page-options="[0]"
      flat
      @update:selected="$emit('update:selected', $event)"
    >
      <template v-slot:body-cell-assignedAt="props">
        <q-td :props="props">
            <humanize-time :time="props.value" />
        </q-td>
      </template>
      <template v-slot:no-data>
        <message v-show="!isLoading" class="full-width">
          User is not assigned to any clients.
        </message>
      </template>
    </q-table>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { UserClient } from '@/type';
import { HasTaskMixin } from '@/mixins';
import Message from '@/components/message/Message.vue';
import { filter } from '@/user-client/user-client';
import clientUserRepository from './clientUserRepository';

interface Data {
  task: Promise<UserClient[]>|null,
  columns: object[],
  clientUsers: UserClient[],
}

export default defineComponent({
  emits: ['update:selected'],
  components: { Message },
  mixins: [HasTaskMixin],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    selected: {
      type: Array as () => UserClient[],
      default() {
        return [];
      },
    },
    keyword: String,
  },
  data(): Data {
    return {
      task: null,
      columns: [
        {
          name: 'name',
          label: 'Name',
          field: (cu: UserClient) => `${cu.user.firstName} ${cu.user.lastName}`,
          align: 'left',
        },
        {
          name: 'email',
          label: 'E-mail',
          field: (cu: UserClient) => cu.user.email,
          align: 'left',
        },
      ],
      clientUsers: [],
    };
  },
  watch: {
    clientId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    filteredClientUsers(): UserClient[] {
      return filter(this.keyword || null, this.clientUsers);
    },
  },
  methods: {
    selectedLabel(): string {
      const count = this.selected.length;
      const total = this.clientUsers.length;
      return `${count} client${(count === 1) ? '' : 's'} selected of ${total}`;
    },
    load() {
      this.task = clientUserRepository.findAll(this.clientId);
      this.task.then((clientUsers: UserClient[]) => {
        this.clientUsers = clientUsers;
      });
    },
    removeItem(clientUser: UserClient) {
      const index = this.clientUsers.findIndex(cu => cu.id === clientUser.id);
      if (index >= 0) {
        this.clientUsers.splice(index, 1);
      }
    },
  },
});
</script>
